import React from "react"
import { Link } from "react-router-dom"
import classes from './Header.module.scss'
const navItems = (props) => {
  return (
    <ul className={[classes[props.navClass], props.addClass].join(' ')}>
      <li className={[classes.navItem, classes.homeLink].join(' ')}><Link to="/">Home</Link></li>
      <li className={classes.navItem}><Link to="/ec-foundation">The Foundation</Link></li>
      <li className={[classes.navItem, classes.run].join(' ')}><Link to="/poker-run">Poker Run CXL'D</Link></li>
      <li className={[classes.navItem, classes.draw, classes.attnMob__when].join(' ')}><Link to="/drawdown">Drawdown</Link></li>
      <li className={[classes.navItem, classes.attn__when].join(' ')}><Link to="/pelican-plunge">Pelican Plunge</Link></li>
      <li className={[classes.navItem, classes.mob].join(' ')}><Link to="/contact">Contact Us</Link></li>
      <li className={[classes.navItem].join(' ')}><Link to="/sponsors">Sponsors</Link></li>
      <li className={[classes.navItem, classes.fw].join(' ')}><Link to="/contact">Contact</Link></li>
    </ul>
  )
}
export default navItems